import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputTitle from 'components/Mobile/InputTitle'

interface Option {
  label: string
  value: string
}

export interface SelectorProps {
  label: string
  description: string
  value: string | null
  options: Option[]
  onChange: (value: string) => void
  disabled?: boolean
}

const Selector = ({ value, label, description, onChange, options, disabled }: SelectorProps) => {
  const menuItems = options.map(({ label, value }) => (
    <MenuItem key={label} value={value}>
      {label}
    </MenuItem>
  ))

  return (
    <InputTitle label={label} description={description}>
      <Select
        variant="filled"
        style={{ width: '100%' }}
        value={value || ''}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        SelectDisplayProps={{ style: { paddingTop: 8, paddingBottom: 8 } }}
        disabled={disabled}
      >
        {menuItems}
      </Select>
    </InputTitle>
  )
}

export default Selector
